import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import BrandclubSideWidget from '../components/BrandclubSideWidget/index.js';
import '../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../types/filters.js';
import { getEntityImage } from '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { escapeUriPath } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import { PLACEHOLDER_GREEN_IMAGE, WIDGET_PAIR_PRODUCT_PADDING } from '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import React from 'react';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '../../types/Campaign.js';
import '../../types/product.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '@brandclub/types';

var ProductAndVideo = function (_a) {
    var _b;
    var _c = _a.product, product = _c === void 0 ? '' : _c, _d = _a.productTitle, productTitle = _d === void 0 ? '' : _d, video = _a.video, coverImage = _a.coverImage, LinkComponent = _a.LinkComponent, persistentQueryParams = _a.persistentQueryParams, page = _a.page;
    var defaultProductValue = 'Add product';
    var hasProduct = product && product !== defaultProductValue;
    var productProps = {
        imageUrl: hasProduct ? getEntityImage(product, 'product') : PLACEHOLDER_GREEN_IMAGE['1X1'],
        imageLink: {
            id: hasProduct
                ? "/".concat(escapeUriPath(productTitle.substring(0, 40)), "/p/").concat(product, "/product?").concat(persistentQueryParams || '')
                : "?".concat(persistentQueryParams || '', "#"),
            displayName: '',
        },
    };
    var fullWidth = !!((_b = page === null || page === void 0 ? void 0 : page.containerConfigOverride) === null || _b === void 0 ? void 0 : _b.width);
    return (React.createElement(BrandclubSideWidget, { fullWidth: fullWidth, leftSideProps: __assign(__assign({ type: 'image' }, productProps), { imageStyle: {
                boxSizing: 'border-box',
                padding: hasProduct ? WIDGET_PAIR_PRODUCT_PADDING : 0,
            } }), rightSideProps: {
            type: 'video',
            video: video,
            coverImage: coverImage,
        }, LinkComponent: LinkComponent }));
};

export { ProductAndVideo };
//# sourceMappingURL=index.js.map
